export const MARKETING_PAGE_TABS = [
  {
    id: "welcome",
    name: "Welcome",
  },
  {
    id: "faq",
    name: "FAQ",
  },
  // {
  //   id: "partyExamples",
  //   name: "Party examples",
  // },
  {
    id: "aboutUs",
    name: "About us",
  },
];
